export const WORKOUT_SORT_OPTIONS = [
  {
    label: 'Date - Asc',
    value: 'dateasc',
  },
  {
    label: 'Date - Desc',
    value: 'datedesc',
  },
  {
    label: 'Type - Asc',
    value: 'typeasc',
  },
  {
    label: 'Type - Desc',
    value: 'typedesc',
  },
  {
    label: 'Duration - Asc',
    value: 'durationasc',
  },
  {
    label: 'Duration - Desc',
    value: 'durationdesc',
  },
];
